import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import { Modal, message } from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const evaluators = []

const headers = utils.columns([
    { type: 'selection' },
    { key: '$index', label: '序号', width: 75 },
    { key: 'dudaoName', label: '评价人', width: 120 },
    { key: 'customerCode', label: '评价人工号', width: 120 },
    { key: 'avgScore', label: '平均分', width: 120 },
    { key: 'evalNum', label: '评价次数', width: 120 },
    { key: 'stdDeviation', label: '标准差', width: 120, render: value => Number(value).toFixed(3) },
    { key: 'bgTermName', label: '开始学期', notSort: true },
    { key: 'endTermName', label: '结束学期', notSort: true }
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {

    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('eval/result/list/total/forEvaluator', Object.assign(defaultsParams, keywords))
        .then(response => {
            const data = response.payload.data;
            if (data.dataList) {
                for (let i = 0; i < data.dataList.length; i++) {
                    let d = data.dataList[i];
                    evaluators.push({id: d.ids, name: d.dudaoName});
                }
            }
            return {
                data: response.payload.data,
                meta: response.payload.meta
            };
        })
        .then(response => (Object.assign({
            meta: response.meta,
            result: response.data.dataList || [],
            selects: (response.data.dataList || []).map(d => ({
                value: d.ids,
                checked: false
            })),
            checked: false,
            total: response.data.total,
            pageIndex: response.data.pageNum,
            pageSize: response.data.pageSize,
            notify: (response.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

/**
 * @method batchSubmit
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const batchSubmit = (id, data) => {
    return fetch.post('eval/result/batch/submit' + id, data)
        .then(response => {
            console.log('success');
        }).catch(error => {
            console.log('error');
        });
}

/**
 * @method batchBack
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const batchBack = (id, data) => {
    return fetch.post('eval/result/batch/back' + id, data)
        .then(response => {
            console.log('success');
        }).catch(error => {
            console.log('error');
        });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('eval/result/update' + id, data)
        .then(response => {
            console.log('success');
        }).catch(error => {
            console.log('error');
        });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('eval/result/remove', ids)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if (DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText: "确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if (response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() { },
            okText: "确认",
            cancelText: "取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result' + url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if (DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText: "确认",
        });
    } else {
        redirect('/update/' + DataGrid.selections[0]);
    }
}

const getSelection = () => {
    return DataGrid.selections;
}

export default {
    querySearch,
    batchSubmit,
    batchBack,
    update,
    remove,
    headers,
    evaluators,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection
}